export default {
  init() {
    this.listenForAnalyticsInit()
    .then((ga) => {
      document.addEventListener('click', event => {
        this.setPDFDowloadAction(ga, event);
      });
    })
    .catch();
  },

  /**
   * Check if GA is initialised
   * abort after 3s, user has probably denied loading Google Analytics.
   */
  listenForAnalyticsInit() {
    return new Promise((resolve, reject) => {
      const timeStart = Date.now();
      const TIMEOUT = 3000;
      const _isLoaded = function() {
        if (Date.now() - timeStart > TIMEOUT) {
          reject('Timeout. Google analytics not injected!');
          return;
        }
        // eslint-disable-next-line no-undef
        if (window['ga'] && ga.create) {
          // eslint-disable-next-line no-undef
          resolve(ga);
          return;
        } else {
          setTimeout(_isLoaded, 500);
        }
      };
      _isLoaded();
    });
  },

  /**
   * Track PDF clicks
   */
  setPDFDowloadAction(ga, event) {

    const isPDFLink = event.target.tagName.toLowerCase() === 'a' && event.target.href.includes('.pdf');
    if ( isPDFLink ) {
      ga('send', 'pageview', event.target.href);
    }
  },
}
